import { render, staticRenderFns } from "./businesstypeinfo.vue?vue&type=template&id=4dd50142&"
import script from "./businesstypeinfo.vue?vue&type=script&lang=js&"
export * from "./businesstypeinfo.vue?vue&type=script&lang=js&"
import style0 from "./businesstypeinfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports